var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatures3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#243A76;}\r\n\t.st1{fill:#152456;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#FBB034;}\r\n\t.st4{clip-path:url(#SVGID_2_);}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.3985;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FBB034;stroke-width:1.3985;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:1.5539;stroke-miterlimit:10;}\r\n\t.st8{fill:none;}\r\n\t.st9{fill:none;stroke:#FBB034;stroke-width:2.8346;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.8,40.9 19.6,40.9 23.8,37.2 22.9,36.2 16.6,41.6 22.9,46.8 23.8,45.7 19.6,42.3 32.8,42.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.4,27.5H32v7.7h1.6V29h14.8v5.4h-7.2v9.3h-2.7v10.4h-4.9v-5.6H32v5.7L18.7,68.5h19l11.8-12.9h4.9 c-1.8,1.2-3,3.2-3,5.5c0,3.7,3,6.7,6.7,6.7c2.6,0,4.8-1.4,5.9-3.6c1.1,2.1,3.3,3.6,5.9,3.6c3.7,0,6.7-3,6.7-6.7 c0-2.3-1.2-4.3-3-5.5h5.7v-1.6H49.9V29h29.5V27.5z M42.8,36h5.6v7.7h-5.6V36z M37.1,67H22.3l10.5-11.4v0.1h14.6L37.1,67z  M58.2,66.3c-2.8,0-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1S61,66.3,58.2,66.3z M75.1,61.2c0,2.8-2.3,5.1-5.1,5.1 s-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1S75.1,58.4,75.1,61.2z M64.1,58.1c-0.5-1-1.3-1.8-2.2-2.4h4.4C65.4,56.3,64.6,57.1,64.1,58.1z  M40,54.1v-8.9h8.3v8.9H40z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 44.5,
    className: "st2",
    width: 1.6,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.4,
    y: 44.5,
    className: "st2",
    width: 1.6,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.4,
    y: 44.5,
    className: "st2",
    width: 1.6,
    height: 4.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures3);
export default __webpack_public_path__ + "static/media/features3.d779632b64367fd52b6ffcf14f9e45f7.svg";
export { ForwardRef as ReactComponent };